export const DEFAULT_FLAG_COLOR = 'default';

export const FLAG_COLOR_OPTIONS = [
  {
    value: DEFAULT_FLAG_COLOR,
    label: 'Default',
    swatch: '#f4ebe3',
    selected: '#8a6a55',
    background: null,
  },
  {
    value: 'sea-green',
    label: 'Sea Green',
    swatch: '#2f8f73',
    selected: '#1f6f58',
    background:
      'radial-gradient(circle at top left, rgba(47, 143, 115, 0.28), transparent 58%), linear-gradient(180deg, #e6f5ef 0%, #d7eee5 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'ocean',
    label: 'Ocean',
    swatch: '#2d7da5',
    selected: '#246988',
    background:
      'radial-gradient(circle at top left, rgba(45, 125, 165, 0.26), transparent 58%), linear-gradient(180deg, #e4f2f7 0%, #d4eaf2 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'blue',
    label: 'Blue',
    swatch: '#4d78bd',
    selected: '#3d619a',
    background:
      'radial-gradient(circle at top left, rgba(77, 120, 189, 0.25), transparent 58%), linear-gradient(180deg, #e9effb 0%, #dbe5f8 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'teal',
    label: 'Teal',
    swatch: '#2f9aa0',
    selected: '#24777c',
    background:
      'radial-gradient(circle at top left, rgba(47, 154, 160, 0.26), transparent 58%), linear-gradient(180deg, #e5f5f5 0%, #d6eeee 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'forest-green',
    label: 'Forest Green',
    swatch: '#719191',
    selected: '#567575',
    background:
      'radial-gradient(circle at top left, rgba(113, 145, 145, 0.28), transparent 58%), linear-gradient(180deg, #edf3f3 0%, #dde8e8 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'obsidian',
    label: 'Obsidian',
    swatch: '#020403',
    selected: '#020403',
    background:
      'radial-gradient(circle at top left, rgba(2, 4, 3, 0.24), transparent 58%), linear-gradient(180deg, #f2f2f2 0%, #dedede 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'mint',
    label: 'Mint',
    swatch: '#63a96f',
    selected: '#4e8657',
    background:
      'radial-gradient(circle at top left, rgba(99, 169, 111, 0.24), transparent 58%), linear-gradient(180deg, #ebf6ed 0%, #dff0e2 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'gold',
    label: 'Gold',
    swatch: '#c79334',
    selected: '#956b22',
    background:
      'radial-gradient(circle at top left, rgba(199, 147, 52, 0.25), transparent 58%), linear-gradient(180deg, #fbf1dc 0%, #f4e4bf 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'coral',
    label: 'Coral',
    swatch: '#d76f56',
    selected: '#a9503d',
    background:
      'radial-gradient(circle at top left, rgba(215, 111, 86, 0.24), transparent 58%), linear-gradient(180deg, #faebe7 0%, #f4dcd6 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'rose',
    label: 'Rose',
    swatch: '#c4657f',
    selected: '#9b4f64',
    background:
      'radial-gradient(circle at top left, rgba(196, 101, 127, 0.22), transparent 58%), linear-gradient(180deg, #f8eaf0 0%, #efd9e2 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
  {
    value: 'lavender',
    label: 'Lavender',
    swatch: '#7b6bbb',
    selected: '#62549a',
    background:
      'radial-gradient(circle at top left, rgba(123, 107, 187, 0.22), transparent 58%), linear-gradient(180deg, #efecfa 0%, #e3def5 62%, rgba(255,255,255,0.78) 88%, #ffffff 100%)',
  },
];

export function getFlagColorOption(value) {
  const normalizedValue = value === 'dark-silver' ? 'forest-green' : value;
  return FLAG_COLOR_OPTIONS.find((option) => option.value === normalizedValue) || FLAG_COLOR_OPTIONS[0];
}
